var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"overflowable",style:({ height: this.$store.state.availableTableHeight }),attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('template-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }